import { motion, AnimatePresence } from 'framer-motion';
import { Loader2, Copy, Check } from 'lucide-react';

const MessageList = ({
  messages,
  streaming,
  streamingContent,
  loading,
  formatMessageContent,
  copyToClipboard,
  copiedId,
  messagesEndRef
}) => {
  return (
    <div className="space-y-6">
      <AnimatePresence initial={false}>
        {messages.map((message) => (
          <motion.div
            key={message.id}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.2 }}
            className={`flex ${message.role === 'user' ? 'justify-end' : 'justify-start'} group`}
          >
            <div className="relative max-w-[85%]">
              <div
                className={`${
                  message.role === 'user'
                    ? 'bg-foreground text-background rounded-2xl rounded-tr-sm px-4 py-3'
                    : 'bg-muted text-foreground rounded-2xl rounded-tl-sm px-4 py-3'
                }`}
              >
                <div className="text-sm sm:text-base leading-relaxed space-y-2">
                  {formatMessageContent(message.content)}
                </div>
              </div>
              {message.role === 'assistant' && (
                <button
                  onClick={() => copyToClipboard(message.content, message.id)}
                  className="absolute -right-10 top-2 opacity-0 group-hover:opacity-100 transition-opacity p-1.5 rounded-md hover:bg-muted"
                  title="Copy to clipboard"
                  data-testid={`copy-btn-${message.id}`}
                >
                  {copiedId === message.id ? (
                    <Check className="h-4 w-4 text-emerald-500" />
                  ) : (
                    <Copy className="h-4 w-4 text-muted-foreground" />
                  )}
                </button>
              )}
            </div>
          </motion.div>
        ))}
      </AnimatePresence>

      {streaming && streamingContent && (
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          className="flex justify-start"
        >
          <div className="max-w-[85%] bg-muted text-foreground rounded-2xl rounded-tl-sm px-4 py-3">
            <div className="text-sm sm:text-base leading-relaxed space-y-2 streaming-cursor">
              {formatMessageContent(streamingContent)}
            </div>
          </div>
        </motion.div>
      )}

      {loading && !streamingContent && (
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          className="flex justify-start"
        >
          <div className="bg-muted text-muted-foreground rounded-2xl rounded-tl-sm px-4 py-3">
            <div className="flex items-center gap-2">
              <Loader2 className="h-4 w-4 animate-spin" />
              <span className="text-sm">Thinking...</span>
            </div>
          </div>
        </motion.div>
      )}

      <div ref={messagesEndRef} />
    </div>
  );
};

export default MessageList;
